import Vue from 'vue'
import { URL_DELIVERY_BASISES, URL_INCOTERMS } from '@/constants/urls'
import { DELIVERY_BASISES_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [DELIVERY_BASISES_MANAGEMENT.STATE.CURRENT]: null,
  [DELIVERY_BASISES_MANAGEMENT.STATE.DELIVERY_BASISES]: null
}

const actions = {
  async [DELIVERY_BASISES_MANAGEMENT.ACTIONS.GET_DELIVERY_BASISES] ({ dispatch, commit }, params) {
    const model = {
      url: `${Vue.getBusinessHost()}${URL_DELIVERY_BASISES}?${Vue.helpers.getQueryParamsString(params)}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(DELIVERY_BASISES_MANAGEMENT.MUTATIONS.GET_DELIVERY_BASISES, resp.data)
  },
  async [DELIVERY_BASISES_MANAGEMENT.ACTIONS.EDIT_DELIVERY_BASIS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_DELIVERY_BASISES}/${model.deliveryBasisRevisionId}`,
      model: model
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [DELIVERY_BASISES_MANAGEMENT.ACTIONS.ADD_DELIVERY_BASIS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_INCOTERMS}/${model.incotermId}/deliveryBasises`,
      model: model.deliveryBasis
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [DELIVERY_BASISES_MANAGEMENT.ACTIONS.DELETE_DELIVERY_BASIS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_DELIVERY_BASISES}/${model.deliveryBasisId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [DELIVERY_BASISES_MANAGEMENT.ACTIONS.CLEAR_DELIVERY_BASISES] ({ commit }) {
    commit(DELIVERY_BASISES_MANAGEMENT.MUTATIONS.CLEAR_DELIVERY_BASISES)
  }
}

const mutations = {
  [DELIVERY_BASISES_MANAGEMENT.MUTATIONS.GET_DELIVERY_BASISES] (state, model) {
    state[DELIVERY_BASISES_MANAGEMENT.STATE.DELIVERY_BASISES] = model
  },
  [DELIVERY_BASISES_MANAGEMENT.MUTATIONS.CLEAR_DELIVERY_BASISES] (state) {
    state[DELIVERY_BASISES_MANAGEMENT.STATE.DELIVERY_BASISES] = null
  }

}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
